import WhatHappensNext from './WhatHappensNext';

export default WhatHappensNext;
